import Api from "../api/Api";
import {useMutation, useQuery} from "@tanstack/react-query";
import {QUERY_KEYS} from "./queryKeys";

export const useFileUploadMutation = () => {
  return useMutation({
    mutationFn: async ({
     fileType,
     fileNum,
     orderId,
     fileData
   }: {
      fileType: string;
      fileNum: number;
      orderId: string;
      fileData: File[]
    }) => {
      return Api.fileEndPoint.uploadFile(fileType, fileNum, orderId, fileData);
    },
  });
};


export const useFileStatusPollingQuery = (orderId: string, isEnabled = false) => {
  return useQuery({
    queryKey: [QUERY_KEYS.upload.checkStatus, orderId],
    queryFn: () => Api.fileEndPoint.checkFileStatus(orderId),
    enabled: !!orderId && isEnabled,
    refetchInterval: (data) => data ? false : 5000,
    refetchIntervalInBackground: false,
    staleTime: 0
  });
};

export const useGetGeojsonShapeFileQuery = (orderId: string, uploadedFileName: string,isEnabled = false) => {
  return useQuery({
    queryKey:[QUERY_KEYS.upload.geojsonShapeFile, orderId, uploadedFileName],
    queryFn: () => Api.fileEndPoint.getGeoJsonLayer(orderId, 'FF5733'),
    enabled: !!orderId && !!uploadedFileName && isEnabled,
    staleTime: 0
  })
}
